import { Controller } from "@hotwired/stimulus"

// Simple form controller for auto-submit on change
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
